import {createClient} from '@supabase/supabase-js';

const SUPABASE_URL = 'https://rrgjvtdptwvizfinixhl.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJyZ2p2dGRwdHd2aXpmaW5peGhsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA3NjkyNzQsImV4cCI6MjEwNjM0NTI3NH0.7PV04wOkl3WX5HFomJJQDRLHgyBg3RqfnivmuewoClY';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase configuration');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;